import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/hosting/wordpress-hosting")({ beforeLoad: redirectTo("/hosting/web/wordpress-hosting") });
